import { computed, getCurrentInstance } from 'vue';

export function useRouter() {
  const instance = getCurrentInstance();
  if (!instance) {
    throw new Error('未找到 `this.$router`');
  }
  return {
    route: computed(() => instance?.proxy?.$route),
    router: computed(() => instance?.proxy?.$router),
  };
}
